import { Box, Grid, Stack, styled } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import {
  ControlledTextInput,
  Label,
  WsButton,
  WsColors,
  WsDateTimePicker,
  WsInputNumber,
  WsSelect,
  WsSelectObj,
} from 'wisestep-base';

import { createCurrencyObject } from '../../../helper/CurrencyHelper';

const ContractHeading = styled(Label)(() => ({
  color: WsColors.TheBlues600,
  fontWeight: 'bold',
  margin: '10px 0px',
}));

const AvailableHeading = styled(Label)(() => ({
  color: WsColors.TheBlues600,
  fontWeight: 'bold',
  margin: '10px 0px',
}));

const SecondaryInfo = ({ newConsultant, setCurrentTab }) => {
  const currencyOptions: WsSelectObj[] = createCurrencyObject();
  const options: WsSelectObj[] = [
    {
      label: 'Prospect',
      value: 'New',
    },
    {
      label: 'Active',
      value: 'Active',
    },
    {
      label: 'Inactive',
      value: 'Inactive',
    },
  ];

  const options1: WsSelectObj[] = [
    {
      label: 'Not Available',
      value: 'NotAvailable',
    },
    {
      label: 'Available Immediately',
      value: 'AvailableImmediately',
    },
    {
      label: 'Available in 7 Days',
      value: 'AvailableIn7Days',
    },
    {
      label: 'Available In 15 Days',
      value: 'AvailableIn15Days',
    },
    {
      label: 'Available In 30 Days',
      value: 'AvailableIn30Days',
    },
  ];

  const onSubmit = (data) => {
    newConsultant(data);
    setCurrentTab(2);
    console.log(data);
  };

  const methods = useForm({
    defaultValues: {
      availability: 'NotAvailable',
      status: 'New',
    },
  });

  return (
    <FormProvider {...methods}>
      <Box>
        <ContractHeading>Contract Info</ContractHeading>
        <Grid container spacing={3} columnSpacing={3}>
          <Grid item xs={6}>
            <ControlledTextInput
              name="contractDetails[0].contractCompany"
              labelText="Contract Company"
              type="text"
              fullWidth
              placeholder="Contract Company"
            />
          </Grid>
          <Grid item xs={6}>
            <ControlledTextInput
              name="contractDetails[0].jobTitle"
              labelText="Job Title"
              type="text"
              fullWidth
              placeholder="Contract Job Title"
            />
          </Grid>
          <Grid item xs={6}>
            <WsDateTimePicker
              name="contractDetails[0].contractStartDate"
              label="Contract Start Date"
            />
          </Grid>
          <Grid item xs={6}>
            <WsDateTimePicker name="contractDetails[0].contractEndDate" label="Contract End Date" />
          </Grid>
          <Grid item xs={6} display="flex" columnGap={3}>
            <WsSelect
              name="contractDetails[0].salaryCurrency"
              label="Pay/Hour"
              selectArray={currencyOptions}
            />
            <WsInputNumber name="salaryPerHour" label="Rate/Hour" />
          </Grid>
        </Grid>
      </Box>
      <Box pt={4}>
        <AvailableHeading>Availability Detail</AvailableHeading>
        <Grid container spacing={3} columnSpacing={3}>
          <Grid item xs={6}>
            <WsSelect name="status" label="Consultants Status" selectArray={options} />
          </Grid>
          <Grid item xs={6}>
            <WsSelect name="availability" label="Availability" selectArray={options1} />
          </Grid>

          <Stack width="100%" direction="row" justifyContent="flex-end" mt={1} gap={2}>
            <WsButton onClick={() => setCurrentTab(0)}>Previous</WsButton>
            <WsButton onClick={methods.handleSubmit(onSubmit, (e) => console.log(e))}>
              Next
            </WsButton>
          </Stack>
        </Grid>
      </Box>
    </FormProvider>
  );
};
export default SecondaryInfo;
